import { Component, HostListener } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DriverRecordRequestService } from '../../../services/driverrecordrequest.service';
import { IWizard } from '../../../interfaces/iwizard';
import { WizardSteps } from '../../../interfaces/wizard-steps';
import { ActivatedRoute, Router } from '@angular/router';
import { DateTime } from 'luxon';

@Component({
    selector: 'app-contact-info',
    templateUrl: './contact-info.component.html',
    styleUrls: ['./contact-info.component.scss'],
    standalone: false
})
export class ContactInfoComponent {

     form!: FormGroup;
     public wizard!: IWizard;
     _step = 4;

     hasStandardDOBError: boolean = false;
     hasInvalidDOBError: boolean = false;
     isTooYoungError: boolean = false;
     minDateOfBirth: DateTime | any;
     letters: RegExp = /^[A-Za-z]+$/;
     numbers: RegExp = /^[0-9]+$/;
     nameRegex: RegExp = /^([a-zA-Z ']*)$/;
     dateOfBirthString: string = '';

     constructor (public service: DriverRecordRequestService, public _router: Router, private route: ActivatedRoute) {
          this.wizard = this.service.getWizard();
     }

     ngOnInit(): void {
          setTimeout(() => this.scrollToTop(), 500);

          if (this.service.isDriverRequestInitialized === false && this.service.loadFromLocal() === false) {
               this._router.navigateByUrl('/driver/1');
          }

          if (this.service.driverRequest.dateOfBirth && this.service.driverRequest.dateOfBirth.isValid) {
               let dob = '';
               // MMddYYYY
               if (this.service.driverRequest.dateOfBirth.month < 10) {
                    dob += '0';
               }
               dob += this.service.driverRequest.dateOfBirth.month;
               if (this.service.driverRequest.dateOfBirth.day < 10) {
                    dob += '0';
               }
               dob += this.service.driverRequest.dateOfBirth.day;
               dob += this.service.driverRequest.dateOfBirth.year;
               this.dateOfBirthString = dob;
          }

          // Define inputs with validations 
          this.form = new FormGroup({
               firstName: new FormControl(this.service.driverRequest.firstName, [
                    Validators.required,
                    Validators.maxLength(30),
                    Validators.pattern(/^([a-zA-Z ']*)$/)
               ]),
               middleInitial: new FormControl(this.service.driverRequest.middleInitial, [
                    Validators.maxLength(10),
                    Validators.pattern(/^([a-zA-Z ]*)$/)
               ]),
               lastName: new FormControl(this.service.driverRequest.lastName, [
                    Validators.required,
                    Validators.maxLength(30),
                    Validators.pattern(/^([a-zA-Z ']*)$/)
               ]),
               suffix: new FormControl(this.service.driverRequest.suffix, [
                    Validators.maxLength(10),
                    Validators.pattern(/^([a-zA-Z ]*)$/)
               ]),
               dateOfBirth: new FormControl(this.dateOfBirthString, [
                    Validators.required,
                    Validators.minLength(8),
                    Validators.maxLength(8)
               ])
          });

          this.minDateOfBirth = DateTime.now().plus({ years: -18 });
     }

     get firstName() { return this.form!.get('firstName'); }
     get middleInitial() { return this.form!.get('middleInitial'); }
     get lastName() { return this.form!.get('lastName'); }
     get suffix() { return this.form!.get('suffix'); }
     get dateOfBirth() { return this.form!.get('dateOfBirth'); }

     ngOnDestroy() {
          this.service.driverRequest.firstName = this.form.get('firstName')?.value;
          this.service.driverRequest.middleInitial = this.form.get('middleInitial')?.value;
          this.service.driverRequest.lastName = this.form.get('lastName')?.value;
          this.service.driverRequest.suffix = this.form.get('suffix')?.value;
          this.service.driverRequest.dateOfBirth = this.parseDateOfBirth();

          this.service.saveToLocal();
     }

     dateOfBirthChanged() {
          this.isTooYoungError = false;
          this.hasInvalidDOBError = false;
          this.hasStandardDOBError = false;

          var dob = this.parseDateOfBirth();
          if (dob) {
               const isValid = dob.isValid && dob.year > 1900;
               if (!isValid) {
                    this.hasInvalidDOBError = true;
               } else {
                    const isTooYoung = dob > this.minDateOfBirth;
                    if (isTooYoung) {
                         this.isTooYoungError = true;
                    }
               }
          } else {
               this.hasStandardDOBError = true;
          }
     }

     parseDateOfBirth(): DateTime | any {
          if (this.form.get('dateOfBirth')?.value && this.form.get('dateOfBirth')?.status === 'VALID') {
               const dobString = this.form.get('dateOfBirth')?.value;
               const month = Number(dobString.substring(0,2));
               const day = Number(dobString.substring(2, 4));
               const year = Number(dobString.substring(4, 8));

               return DateTime.fromObject({ year: year, month: month, day: day, hour: 12, minute: 0 });
          }
          return null;
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }

     @HostListener('window:beforeunload', ['$event'])
     unloadMessage($event: { returnValue: string; }) {
          return $event.returnValue = 'Your changes will not be saved';
     }

     getStepForPercentComplete() {
          if (this.service.isReorder()) {
               return 2;
          } else {
               return this._step;
          }
     }
}
